import { Box, Checkbox, CircularProgress, Container, FormControlLabel, Grid, Modal, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, styled, tableCellClasses } from '@mui/material';
import React from 'react'
import { Component } from 'react'
import ReactHtmlTableToExcel from 'react-html-table-to-excel';
import Constantes from '../php/Constantes';

const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

class PlanillaDescuento extends Component {
    constructor(props){
        super(props);
        this.state = {
            consulta: false,
            loading: false,
            errores: null,
            notificaciones: null,
            consultaPlanilla: {
                ubicacion: '',
                ubicacionCentral: '',
                numeroFuncionario: '',
                nombreFuncionario: '',
                mes: '',
                anio: '',
            },

            datosConsulta: {},
            consultaFuncionario: false,

            numeroNombre: [],
            lugaresTra: [],
            ubicacionesCentral: [],
            modalActualizar: false,

            movEditar: {
                idDescuentosMensuales: '',
                numeroFuncionario: '',
                nombreFuncionario: '',
                descuentoE: '',
                descuentoS: '',
                descuentoMH: '',
                totalInasistencias: '',
                inasistenciasCon: '',
                inasistenciasSin: '',
                paro: '',
                mes: '',
                anio: '',
                conDatos: '',
            },

            checkDescuentos:{
                todo: true,
                confirmado: false,
                sinConfirmar: false,
            },

            confirmadoConsulta: [],
            sinConfirmarConsulta: [],

            consultaEspecifica: false,
        }

        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejoEnvioConsulta = this.manejoEnvioConsulta.bind(this);
        this.manejarCambiosDatosConsulta = this.manejarCambiosDatosConsulta.bind(this);
        this.manejarAtrasCon = this.manejarAtrasCon.bind(this);
        this.manejarEdicion = this.manejarEdicion.bind(this);
        this.manejarEnvioModificar = this.manejarEnvioModificar.bind(this);
        this.cerrarModal = this.cerrarModal.bind(this);
        this.manejarAtrasConEsp = this.manejarAtrasConEsp.bind(this);
        this.manejarEnvioConfirmacion = this.manejarEnvioConfirmacion.bind(this);
        this.manejarAtrasConTod = this.manejarAtrasConTod.bind(this);
        this.cambioListadoConsulta = this.cambioListadoConsulta.bind(this);
    }

    async componentDidMount(){
        const numNom = await fetch(`${Constantes.RUTA_API}/obtener_numerosNombre.php`);
        const datosNumNom = await numNom.json();
        this.setState({
            numeroNombre: datosNumNom,
        });

        const lugar = await fetch(`${Constantes.RUTA_API}/obtener_lugaresTrabajo.php`);
        const datoLugar = await lugar.json();
        this.setState({
            lugaresTra: datoLugar,
        });


        const lugarCentral = await fetch(`${Constantes.RUTA_API}/obtener_ubicacionesCentral.php`);
        const datoLugarCentral = await lugarCentral.json();
        this.setState({
            ubicacionesCentral: datoLugarCentral,
        });
    }

    render(){
        return (
            <>
                <Container>
                    <h3>Planilla Descuento Mensual</h3>
                    {this.state.loading
                    ?
                        <div style={{placeItems: 'center'}}>
                            <Box sx={{alignItems: 'center'}}>
                                <CircularProgress/>
                            </Box>
                        </div>
                    :
                        null
                    }
                    <br/>
                    {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                    {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                    <br/>
                    {this.state.consulta && (!this.state.consultaEspecifica) ?
                        <ReactHtmlTableToExcel id="botonExportarExcel" className="btn btn-outline-success" table="tablaConsulta" filename="prueba" sheet="pagina 1" buttonText="Exportar a Excel">
                        </ReactHtmlTableToExcel>
                    :
                        null
                    }
                    {this.state.consulta || this.state.consultaFuncionario
                    ?
                        null
                    :
                        <Container>
                            <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                <Table sx={{minWidth: 700}}>
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>Numero Funcionario</StyledTableCell>
                                            <StyledTableCell>Nombre Funcionario</StyledTableCell>
                                            <StyledTableCell>Ubicación</StyledTableCell>
                                            {this.state.consultaPlanilla.ubicacion === '0' ? <StyledTableCell width={'16%'}>Ubicación Central</StyledTableCell> : null}
                                            <StyledTableCell>Mes</StyledTableCell>
                                            <StyledTableCell>Año</StyledTableCell>
                                            <StyledTableCell></StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <StyledTableRow>
                                            <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='numeroFuncionario' value={this.state.consultaPlanilla.numeroFuncionario} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                            <StyledTableCell>{this.state.consultaPlanilla.nombreFuncionario}</StyledTableCell>
                                            <StyledTableCell>
                                                <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='ubicacion'  value={this.state.consultaPlanilla.ubicacion} onChange={this.manejarCambiosDatos}>
                                                    <option value=''>UBICACION</option>
                                                    {this.state.lugaresTra.map((name) =>
                                                        <option
                                                        key={name.idLugaresTrabajo}
                                                        value={name.idLugaresTrabajo}
                                                        >{name.lugar}</option>
                                                        )}
                                                </select>
                                            </StyledTableCell>
                                            {this.state.consultaPlanilla.ubicacion === '0' ?
                                                <StyledTableCell>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='ubicacionCentral'  value={this.state.consultaPlanilla.ubicacionCentral} onChange={this.manejarCambiosDatos}>
                                                        <option value=''>UBICACION</option>
                                                        {this.state.ubicacionesCentral.map((name) =>
                                                            <option
                                                            key={name.idUbicacionesCentral}
                                                            value={name.idUbicacionesCentral}
                                                            >{name.descripcion}
                                                        </option>
                                                            )}
                                                    </select>
                                                </StyledTableCell> : null
                                            }
                                            <StyledTableCell>
                                                <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='mes'  value={this.state.consultaPlanilla.mes} onChange={this.manejarCambiosDatos}>
                                                    <option value=''>MES</option>
                                                    <option value={'01'}>ENERO</option>
                                                    <option value={'02'}>FEBRERO</option>
                                                    <option value={'03'}>MARZO</option>
                                                    <option value={'04'}>ABRIL</option>
                                                    <option value={'05'}>MAYO</option>
                                                    <option value={'06'}>JUNIO</option>
                                                    <option value={'07'}>JULIO</option>
                                                    <option value={'08'}>AGOSTO</option>
                                                    <option value={'09'}>SETIEMBRE</option>
                                                    <option value={'10'}>OCTUBRE</option>
                                                    <option value={'11'}>NOVIEMBRE</option>
                                                    <option value={'12'}>DICIEMBRE</option>
                                                </select>
                                            </StyledTableCell>
                                            <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='anio' value={this.state.consultaPlanilla.anio} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                            <StyledTableCell><button className="btn btn-outline-danger" type='button' onClick={() => this.manejoEnvioConsulta()}>Consultar</button></StyledTableCell>
                                        </StyledTableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Container>
                    }
                    {this.state.consulta && (!this.state.consultaEspecifica)
                    ?
                        <Container>
                            <FormControlLabel label='Todo' control={<Checkbox checked={this.state.checkDescuentos.todo} onChange={this.cambioListadoConsulta} id='todo'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                            <FormControlLabel label='Confirmado' control={<Checkbox checked={this.state.checkDescuentos.confirmado} onChange={this.cambioListadoConsulta} id='confirmado'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                            <FormControlLabel label='Sin Confirmar' control={<Checkbox checked={this.state.checkDescuentos.sinConfirmar} onChange={this.cambioListadoConsulta} id='sinConfirmar'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                        </Container>
                    :
                        null
                    }
                    {this.state.consultaFuncionario && (!this.state.consultaEspecifica)
                    ?
                        <Container>
                            <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                <Table sx={{minWidth: 800}} id="tablaConsulta">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell align="center" colSpan={10}>{this.state.datosConsulta.numeroFuncionario} {this.state.datosConsulta.nombreFuncionario}</StyledTableCell>
                                        </TableRow>
                                        <TableRow>
                                            <StyledTableCell>Descuento E.</StyledTableCell>
                                            <StyledTableCell>Descuento S.</StyledTableCell>
                                            <StyledTableCell>Descuento M.H. Descanso</StyledTableCell>
                                            <StyledTableCell>Total Inasistencias</StyledTableCell>
                                            <StyledTableCell>Mes</StyledTableCell>
                                            <StyledTableCell>Año</StyledTableCell>
                                            <StyledTableCell></StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <StyledTableRow>
                                            {this.state.datosConsulta.confirmado === 0
                                            ?
                                                <StyledTableCell style={{backgroundColor: 'brown'}}>{this.state.datosConsulta.descuentoE}</StyledTableCell>
                                            :
                                                <StyledTableCell>{this.state.datosConsulta.descuentoE}</StyledTableCell>
                                            }
                                            {this.state.datosConsulta.confirmado === 0
                                            ?
                                                <StyledTableCell style={{backgroundColor: 'brown'}}>{this.state.datosConsulta.descuentoS}</StyledTableCell>
                                            :
                                                <StyledTableCell>{this.state.datosConsulta.descuentoS}</StyledTableCell>
                                            }
                                            {this.state.datosConsulta.confirmado === 0
                                            ?
                                                <StyledTableCell style={{backgroundColor: 'brown'}}>{this.state.datosConsulta.descuentoMH}</StyledTableCell>
                                            :
                                                <StyledTableCell>{this.state.datosConsulta.descuentoMH}</StyledTableCell>
                                            }
                                            {this.state.datosConsulta.confirmado === 0
                                            ?
                                                <StyledTableCell style={{backgroundColor: 'brown'}}>{this.state.datosConsulta.totalInasistencias}</StyledTableCell>
                                            :
                                                <StyledTableCell>{this.state.datosConsulta.totalInasistencias}</StyledTableCell>
                                            }
                                            {this.state.datosConsulta.confirmado === 0
                                            ?
                                                <StyledTableCell style={{backgroundColor: 'brown'}}>{this.state.datosConsulta.mes}</StyledTableCell>
                                            :
                                                <StyledTableCell>{this.state.datosConsulta.mes}</StyledTableCell>
                                            }
                                            {this.state.datosConsulta.confirmado === 0
                                            ?
                                                <StyledTableCell style={{backgroundColor: 'brown'}}>{this.state.datosConsulta.anio}</StyledTableCell>
                                            :
                                                <StyledTableCell>{this.state.datosConsulta.anio}</StyledTableCell>
                                            }
                                            {this.state.datosConsulta.confirmado === 0
                                            ?
                                                <StyledTableCell style={{backgroundColor: 'brown'}}><button className="btn btn-outline-blue mx-2" type='button' onClick={() => this.manejarEdicion(this.state.datosConsulta)}>Confirmar/Modificar</button></StyledTableCell>
                                            :
                                                <StyledTableCell><button className="btn btn-outline-blue mx-2" type='button' style={{color: 'brown'}} onClick={() => this.manejarEdicion(this.state.datosConsulta)}>Confirmar/Modificar</button></StyledTableCell>
                                            }
                                        </StyledTableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtrasCon}>Volver</button>
                        </Container>
                    :
                        null
                    }
                    {this.state.consulta && (!this.state.consultaEspecifica) && this.state.checkDescuentos.todo
                    ?
                        <Container>
                            <br/>
                            <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                <Table sx={{minWidth: 700}} id="tablaConsulta">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>Número Funcionario</StyledTableCell>
                                            <StyledTableCell>Nombre Funcionario</StyledTableCell>
                                            <StyledTableCell>Descuento E</StyledTableCell>
                                            <StyledTableCell>Descuento S</StyledTableCell>
                                            <StyledTableCell>Descuento M.H. Descanso</StyledTableCell>
                                            <StyledTableCell>Inasistencia</StyledTableCell>
                                            <StyledTableCell>Mes</StyledTableCell>
                                            <StyledTableCell>Año</StyledTableCell>
                                            <StyledTableCell></StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.datosConsulta.map((dato,index) => (
                                            <StyledTableRow key={index}>
                                                {dato.confirmado
                                                ?
                                                    <StyledTableCell>{dato.numeroFuncionario}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.numeroFuncionario}</StyledTableCell>
                                                }
                                                {dato.confirmado
                                                ?
                                                    <StyledTableCell>{dato.nombreFuncionario}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.nombreFuncionario}</StyledTableCell>
                                                }
                                                {dato.confirmado
                                                ?
                                                    <StyledTableCell>{dato.descuentoE}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.descuentoE}</StyledTableCell>
                                                }
                                                {dato.confirmado
                                                ?
                                                    <StyledTableCell>{dato.descuentoS}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.descuentoS}</StyledTableCell>
                                                }
                                                {dato.confirmado
                                                ?
                                                    <StyledTableCell>{dato.descuentoMH}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.descuentoMH}</StyledTableCell>
                                                }
                                                {dato.confirmado
                                                ?
                                                    <StyledTableCell>{dato.totalInasistencias}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.totalInasistencias}</StyledTableCell>
                                                }
                                                {dato.confirmado
                                                ?
                                                    <StyledTableCell>{dato.mes}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.mes}</StyledTableCell>
                                                }
                                                {dato.confirmado
                                                ?
                                                    <StyledTableCell>{dato.anio}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.anio}</StyledTableCell>
                                                }
                                                {dato.confirmado
                                                ?
                                                    <StyledTableCell><button className="btn btn mx-2" type='button' style={{color: 'brown'}} onClick={() => this.manejarEdicion(dato)}>Confirmar/Modificar</button></StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}><button className="btn btn mx-2" type='button' onClick={() => this.manejarEdicion(dato)}>Confirmar/Modificar</button></StyledTableCell>
                                                }
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtrasCon}>Volver</button>
                        </Container>    
                    :
                        null
                    }
                    {this.state.consulta && (!this.state.consultaEspecifica) && this.state.checkDescuentos.confirmado
                    ?
                        <Container>
                            <br/>
                            <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                <Table sx={{minWidth: 700}} id="tablaConsulta">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>Número Funcionario</StyledTableCell>
                                            <StyledTableCell>Nombre Funcionario</StyledTableCell>
                                            <StyledTableCell>Descuento E</StyledTableCell>
                                            <StyledTableCell>Descuento S</StyledTableCell>
                                            <StyledTableCell>Descuento M.H. Descanso</StyledTableCell>
                                            <StyledTableCell>Inasistencia</StyledTableCell>
                                            <StyledTableCell>Mes</StyledTableCell>
                                            <StyledTableCell>Año</StyledTableCell>
                                            <StyledTableCell></StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.confirmadoConsulta.map((dato,index) => (
                                            <StyledTableRow key={index}>
                                                {dato.confirmado
                                                ?
                                                    <StyledTableCell>{dato.numeroFuncionario}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.numeroFuncionario}</StyledTableCell>
                                                }
                                                {dato.confirmado
                                                ?
                                                    <StyledTableCell>{dato.nombreFuncionario}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.nombreFuncionario}</StyledTableCell>
                                                }
                                                {dato.confirmado
                                                ?
                                                    <StyledTableCell>{dato.descuentoE}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.descuentoE}</StyledTableCell>
                                                }
                                                {dato.confirmado
                                                ?
                                                    <StyledTableCell>{dato.descuentoS}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.descuentoS}</StyledTableCell>
                                                }
                                                {dato.confirmado
                                                ?
                                                    <StyledTableCell>{dato.descuentoMH}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.descuentoMH}</StyledTableCell>
                                                }
                                                {dato.confirmado
                                                ?
                                                    <StyledTableCell>{dato.totalInasistencias}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.totalInasistencias}</StyledTableCell>
                                                }
                                                {dato.confirmado
                                                ?
                                                    <StyledTableCell>{dato.mes}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.mes}</StyledTableCell>
                                                }
                                                {dato.confirmado
                                                ?
                                                    <StyledTableCell>{dato.anio}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.anio}</StyledTableCell>
                                                }
                                                {dato.confirmado
                                                ?
                                                    <StyledTableCell><button className="btn btn mx-2" type='button' style={{color: 'brown'}} onClick={() => this.manejarEdicion(dato)}>Confirmar/Modificar</button></StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}><button className="btn btn mx-2" type='button' onClick={() => this.manejarEdicion(dato)}>Confirmar/Modificar</button></StyledTableCell>
                                                }
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtrasCon}>Volver</button>
                        </Container>    
                    :
                        null
                    }
                    {this.state.consulta && (!this.state.consultaEspecifica) && this.state.checkDescuentos.sinConfirmar
                    ?
                        <Container>
                            <br/>
                            <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                <Table sx={{minWidth: 700}} id="tablaConsulta">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>Número Funcionario</StyledTableCell>
                                            <StyledTableCell>Nombre Funcionario</StyledTableCell>
                                            <StyledTableCell>Descuento E</StyledTableCell>
                                            <StyledTableCell>Descuento S</StyledTableCell>
                                            <StyledTableCell>Descuento M.H. Descanso</StyledTableCell>
                                            <StyledTableCell>Inasistencia</StyledTableCell>
                                            <StyledTableCell>Mes</StyledTableCell>
                                            <StyledTableCell>Año</StyledTableCell>
                                            <StyledTableCell></StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.sinConfirmarConsulta.map((dato,index) => (
                                            <StyledTableRow key={index}>
                                                {dato.confirmado
                                                ?
                                                    <StyledTableCell>{dato.numeroFuncionario}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.numeroFuncionario}</StyledTableCell>
                                                }
                                                {dato.confirmado
                                                ?
                                                    <StyledTableCell>{dato.nombreFuncionario}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.nombreFuncionario}</StyledTableCell>
                                                }
                                                {dato.confirmado
                                                ?
                                                    <StyledTableCell>{dato.descuentoE}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.descuentoE}</StyledTableCell>
                                                }
                                                {dato.confirmado
                                                ?
                                                    <StyledTableCell>{dato.descuentoS}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.descuentoS}</StyledTableCell>
                                                }
                                                {dato.confirmado
                                                ?
                                                    <StyledTableCell>{dato.descuentoMH}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.descuentoMH}</StyledTableCell>
                                                }
                                                {dato.confirmado
                                                ?
                                                    <StyledTableCell>{dato.totalInasistencias}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.totalInasistencias}</StyledTableCell>
                                                }
                                                {dato.confirmado
                                                ?
                                                    <StyledTableCell>{dato.mes}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.mes}</StyledTableCell>
                                                }
                                                {dato.confirmado
                                                ?
                                                    <StyledTableCell>{dato.anio}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.anio}</StyledTableCell>
                                                }
                                                {dato.confirmado
                                                ?
                                                    <StyledTableCell><button className="btn btn mx-2" type='button' style={{color: 'brown'}} onClick={() => this.manejarEdicion(dato)}>Confirmar/Modificar</button></StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}><button className="btn btn mx-2" type='button' onClick={() => this.manejarEdicion(dato)}>Confirmar/Modificar</button></StyledTableCell>
                                                }
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtrasCon}>Volver</button>
                        </Container>    
                    :
                        null
                    }
                    <Modal open={this.state.modalActualizar}>
                        <form className='formulario1'>
                            <Box sx={styleModal} >
                            <h3 style={{textAlign:'center'}}>Editar Movimiento</h3>
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={2}>
                                        <Item>N. Funcionario</Item>
                                    </Grid>
                                    <Grid item xs={3}>
                                        {this.state.movEditar.numeroFuncionario}
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Nombre Funcionario</Item>
                                    </Grid>
                                    <Grid item xs={3}>
                                        {this.state.movEditar.nombreFuncionario}
                                    </Grid>
                                    <Grid item xs={4}>
                                        <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioModificar}>Confirmar</button>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <button className="btn btn-outline-danger mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.cerrarModal}>Cancelar</button>
                                    </Grid>
                                </Grid>
                            </Box>
                        </form>
                    </Modal>
                    {this.state.consultaEspecifica
                    ?
                        <Container>
                            <Box>
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={1.5}>
                                        
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>Numero Funcionario</Item>
                                    </Grid>
                                    <Grid item xs={1.5}>
                                        {this.state.movEditar.numeroFuncionario}
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>Nombre Funcionario</Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        {this.state.movEditar.nombreFuncionario}
                                    </Grid>
                                    <Grid item xs={2}>
                                        
                                    </Grid>
                                    <Grid item xs={1.5}>
                                        
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>Descuento Entrada</Item>
                                    </Grid>
                                    <Grid item xs={1.5}>
                                        <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='descuentoE' value={this.state.movEditar.descuentoE} onChange={this.manejarCambiosDatosConsulta} type="text" />
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>Descuento Salida</Item>
                                    </Grid>
                                    <Grid item xs={1.5}>
                                        <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='descuentoS' value={this.state.movEditar.descuentoS} onChange={this.manejarCambiosDatosConsulta} type="text" />
                                    </Grid>
                                    <Grid item xs={2}>
                                        
                                    </Grid>
                                    <Grid item xs={1.5}>
                                        
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>Descuento Descanso</Item>
                                    </Grid>
                                    <Grid item xs={1.5}>
                                        <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='descuentoMH' value={this.state.movEditar.descuentoMH} onChange={this.manejarCambiosDatosConsulta} type="text" />
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>Inasistencias</Item>
                                    </Grid>
                                    <Grid item xs={1.5}>
                                        {this.state.movEditar.totalInasistencias}
                                    </Grid>
                                    <Grid item xs={2}>
                                        
                                    </Grid>
                                    <Grid item xs={1.5}>
                                        
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>Inasistencias Con Aviso</Item>
                                    </Grid>
                                    <Grid item xs={1.5}>
                                        <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='inasistenciasCon' value={this.state.movEditar.inasistenciasCon} onChange={this.manejarCambiosDatosConsulta} type="text" />
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>Inasistencias Sin Aviso</Item>
                                    </Grid>
                                    <Grid item xs={1.5}>
                                        <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='inasistenciasSin' value={this.state.movEditar.inasistenciasSin} onChange={this.manejarCambiosDatosConsulta} type="text" />
                                    </Grid>
                                    <Grid item xs={2}>
                                        
                                    </Grid>
                                    <Grid item xs={1.5}>
                                        
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Item>Paro</Item>
                                    </Grid>
                                    <Grid item xs={1.5}>
                                        <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='paro' value={this.state.movEditar.paro} onChange={this.manejarCambiosDatosConsulta} type="text" />
                                    </Grid>
                                    <Grid item xs={2.5}></Grid>
                                </Grid>
                            </Box>
                            {this.state.consultaFuncionario && this.state.consultaEspecifica ? <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtrasConEsp}>Volver</button> : null}
                            {this.state.consulta && this.state.consultaEspecifica ? <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtrasConTod}>Volver</button> : null}
                            <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioConfirmacion}>Confirmar</button>
                        </Container>
                    :
                        null
                    }
                </Container>
            </>
        )
    }

    async recargar(){
        this.setState({
            loading: true,
            errores: null,
        });

        const cargaUtil = JSON.stringify([this.state.consultaPlanilla]);

        const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_planillaDescuentoMensual.php`,{
            method: 'POST',
            body: cargaUtil,
        })

        const exito = await respuesta.json();
        this.setState({
            errores: exito[0],
            loading: false,
        })

        if((exito[4] === 'no') && (exito[3] === 1)){
            this.setState({
                loading: false,
                errores: null,
                datosConsulta: exito[1],
                consultaFuncionario: true,
            })
        }else if(((exito[4] === 'si'))){
            this.setState({
                datosConsulta: exito[1],
                confirmadoConsulta: exito[5],
                sinConfirmarConsulta: exito[6],
                consulta: true,
                errores: false,
            })
        }
    }

    manejarCambiosDatos(e){
        e.preventDefault();

        const clave = e.target.id;
        let valor = e.target.value;
        this.setState({
            errores: null,
            notificaciones: null,
            consulta: false,
        });
        this.setState(state => {
            const numFunActualizado = state.consultaPlanilla;
            numFunActualizado[clave] = valor;
            
            if((clave === 'numeroFuncionario') && (valor !== '') ){
                //valor = parseFloat(valor);
                //Tengo que buscar la informacion de ese funcionario
                let aux = true;
                this.state.numeroNombre.map((name) =>
                {if(name.numeroFuncionario === valor){
                    numFunActualizado['nombreFuncionario'] = name.primerNombre + ' ' + name.primerApellido;
                    aux = false;
                }else if(aux){
                    numFunActualizado['nombreFuncionario'] = '';
                }
                });
            }else if((clave === 'nombreFuncionario') && (valor === '')){
                numFunActualizado['nombreFuncionario'] = '';
            }
            
            return{
                consultaPlanilla: numFunActualizado,
            };
        });
    }

    async manejoEnvioConsulta(){
        this.setState({
            errores: null,
            notificaciones: null,
            loading: false,
            consulta: false,
        })
        if((this.state.consultaPlanilla.numeroFuncionario !== '') && (this.state.consultaPlanilla.nombreFuncionario === '')){
            this.setState({
                errores: 'Debe ingresar un número de funcionario valido',
            })
        }else if(this.state.consultaPlanilla.mes === ''){
            this.setState({
                errores: 'Debe ingresar el mes de la consulta',
            })
        }else if(this.state.consultaPlanilla.anio === ''){
            this.setState({
                errores: 'Debe ingresar el año de la consulta',
            })
        }else{
            this.setState({
                loading: true,
                errores: null,
                notificaciones: null,
            });

            const cargaUtil = JSON.stringify([this.state.consultaPlanilla]);

            const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_planillaDescuentoMensual.php`,{
                method: 'POST',
                body: cargaUtil,
            })

            const exito = await respuesta.json();
            this.setState({
                errores: exito[0],
                loading: false,
            })

            if((exito[4] === 'no') && (exito[3] === 1)){
                this.setState({
                    loading: false,
                    errores: null,
                    notificaciones: null,
                    datosConsulta: exito[1],
                    consultaFuncionario: true,
                })
            }else if(((exito[4] === 'si'))){
                this.setState({
                    datosConsulta: exito[1],
                    consulta: true,
                    confirmadoConsulta: exito[5],
                    sinConfirmarConsulta: exito[6],
                    notificaciones: false,
                    errores: false,
                })
            }
        }
    }

    manejarCambiosDatosConsulta(e){
        e.preventDefault();

        const clave = e.target.id;
        let valor = e.target.value;
        this.setState({
            errores: null,
            notificaciones: null,
        });
        this.setState(state => {
            const numFunActualizado = state.movEditar;
            numFunActualizado[clave] = valor;
            
            return{
                movEditar: numFunActualizado,
            };
        });
    }

    manejarAtrasCon(e){
        e.preventDefault();
        this.setState({
            consulta: false,
            consultaFuncionario: false,
            consultaEspecifica: false,
            errores: null,
            notificaciones: null,
            consultaPlanilla: {
                ubicacion: '',
                ubicacionCentral: '',
                numeroFuncionario: '',
                nombreFuncionario: '',
                mes: '',
                anio: '',
            },
        })
    }

    manejarEdicion(dato){
        this.setState({
            movEditar: dato,
            notificaciones: null,
            errores: null,
            consultaEspecifica: true,
        });
    }

    async manejarEnvioModificar(e){
        e.preventDefault();
    }

    cerrarModal(e){
        e.preventDefault();
        this.setState({
            modalActualizar: false,
        })
    }

    manejarAtrasConEsp(e){
        e.preventDefault();
        this.setState({
            consulta: false,
            consultaFuncionario: true,
            consultaEspecifica: false,
        })
    }

    manejarAtrasConTod(e){
        e.preventDefault();
        this.setState({
            consulta: true,
            consultaFuncionario: false,
            consultaEspecifica: false,
        })
    }

    async manejarEnvioConfirmacion(e){
        e.preventDefault();
        if(this.state.movEditar.descuentoE === ''){
            this.setState({
                errores: 'Debe ingresar el descuento de Entrada',
            })
        }else if(this.state.movEditar.descuentoS === ''){
            this.setState({
                errores: 'Debe ingresar el descuento de Salilda',
            })
        }else if(this.state.movEditar.descuentoMH === ''){
            this.setState({
                errores: 'Debe ingresar el descuento de Descanso Intermedio',
            })
        }else if(this.state.movEditar.inasistenciasCon === ''){
            this.setState({
                errores: 'Debe ingresar la cantidad de días de inasistencia con aviso',
            })
        }else if(this.state.movEditar.inasistenciasSin === ''){
            this.setState({
                errores: 'Debe ingresar la cantidad de días de inasistencia sin aviso',
            })
        }else if(this.state.movEditar.paro === ''){
            this.setState({
                errores: 'Debe ingresar la cantidad de días de inasistencia por paro',
            })
        }else{
            const cargaUtil = JSON.stringify([this.state.movEditar]);

            const respuesta = await fetch(`${Constantes.RUTA_API}/guardar_DescuentoMensual.php`,{
                method: 'POST',
                body: cargaUtil,
            })

            const exito = await respuesta.json();
            this.setState({
                errores: exito[0],
                loading: false,
            })

            if(exito[0] === 'ok'){
                this.recargar();
                this.setState({
                    errores: null,
                    consultaEspecifica: false,
                    notificaciones: 'Descuentos ingresados correctamente',
                    movEditar: {
                        idDescuentosMensuales: '',
                        numeroFuncionario: '',
                        nombreFuncionario: '',
                        descuentoE: '',
                        descuentoS: '',
                        descuentoMH: '',
                        totalInasistencias: '',
                        inasistenciasCon: '',
                        inasistenciasSin: '',
                        paro: '',
                        mes: '',
                        anio: '',
                        conDatos: '',
                    },
                })
            }
        }
    }

    cambioListadoConsulta(e){
        const clave = e.target.id;
        let valor = e.target.checked;
        this.setState({
            errores: null,
            notificaciones: null,
        });

        if(clave === 'todo'){

            if(valor){
                this.setState({
                    checkDescuentos: {
                        todo: true,
                        confirmado: false,
                        sinConfirmar: false,
                    },
                });
            }
        }else if(clave === 'confirmado'){
            if(valor){
                this.setState({
                    checkDescuentos: {
                        todo: false,
                        confirmado: true,
                        sinConfirmar: false,
                    },
                });
            }
        }else if(clave === 'sinConfirmar'){
            if(valor){
                this.setState({
                    checkDescuentos: {
                        todo: false,
                        confirmado: false,
                        sinConfirmar: true,
                    },
                });
            }
        }
    }
}

export default PlanillaDescuento